<template>
  <div class="page">
    <div class="page-bd max">
      <div class="table-box pd-20">
        <pageTitle :title="$t('WinmailTitle')" :newButShow="true" @newBut="newBut('add')"></pageTitle>
        <myTableFilter @submit="handleSubmit" :show="{ mail_name: true }" />
        <myTable ref="table" :columns="columns" requestUrl="sys_email/list" :showPage="true">
          <template v-slot:default_status="{ data }">
            <span v-if="data.row.default_status == 1">{{$t("yes")}}</span>
            <span v-else>{{$t("no")}}</span>
          </template>
          <template v-slot:action="{ data }">
            <Icon
              class="cursor_p"
              type="md-create"
              size="24"
              color="#1F8FC8"
              @click="newBut('edit',data.row)"
            />
            <Poptip
              placement="bottom"
              confirm
              :title="$t('confirm_delete')"
              @on-ok="handleDel(data.row)"
            >
              <Icon class="cursor_p mg-left15" type="md-trash" size="24" color="#7D7C7F" />
            </Poptip>
          </template>
        </myTable>
      </div>
    </div>
    <edit v-if="modal" @onOk="onOk" :type="type" :modal="modal" :itemObj="itemObj" @cancel="cancel"></edit>
  </div>
</template>

<script>
import myTable from "@/components/myTable";
import pageTitle from "@/components/pageTitle";
import myTableFilter from "@/components/myTableFilter";
import edit from "./module/mailSetup_edit";
export default {
  name: "mailSetup",
  components: {
    myTable,
    pageTitle,
    myTableFilter,
    edit
  },
  data () {
    return {
      columns: [
        {
          title: this.$t("Info.code"),
          key: "set_id",
          align: "center",
          tooltip: true,
          width: 100,
        },
        {
          title: this.$t("mail_code"),
          key: "email_set_name",
          align: "center",
          tooltip: true,
          minWidth: 150,
        },
        {
          title: this.$t("mail_user_name"),
          key: "mail_user_name",
          align: "center",
          tooltip: true,
          minWidth: 250,
        },
        {
          title: this.$t("mail_password"),
          key: "mail_password",
          align: "center",
          tooltip: true,
          minWidth: 150,
        },
        {
          title: this.$t("mail_per_day"),
          key: "mail_per_day",
          align: "center",
          tooltip: true,
          minWidth: 150,
        },
        {
          title: this.$t("mail_per_hour"),
          key: "mail_per_hour",
          align: "center",
          tooltip: true,
          minWidth: 150,
        },
        {
          title: this.$t("mail_per_minute"),
          key: "mail_per_minute",
          align: "center",
          tooltip: true,
          minWidth: 150,
        },
        {
          title: this.$t("default_status"),
          slot: "default_status",
          align: "center",
          tooltip: true,
          minWidth: 150,
        },
        {
          title: this.$t("op"),
          align: "center",
          slot: "action",
          width: 180,
        },
      ],
      modal: false,
      itemObj: {},
      type: "add"
    };
  },
  created () {
  },
  mounted () {
    this.$base.setMenuOpens();
  },
  methods: {
    handleSubmit (params) {
      this.$refs.table.reSearch(params);
    },
    newBut (type, item) {
      this.type = type
      this.itemObj = item
      this.modal = true
    },
    cancel () {
      this.modal = false
    },
    onOk () {
      this.$base.msgSuccess(this.$t("op_ok"));
      this.$refs.table.getLoad();
    },
    handleDel (item) {
      this.$base.showLoading();
      this.$request.sendPost(
        'sys_email/del',
        { set_id: item.set_id },
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          this.$base.msgSuccess(this.$t("op_ok"));
          this.$refs.table.getLoad();
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .table-box {
  .ivu-icon-ios-help-circle:before {
    content: '';
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    padding-left: 0;
  }
  .ivu-poptip-confirm .ivu-poptip-footer > .ivu-btn {
    padding: 2px 8px;
    font-size: 14px;
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/system/mailSetup/mailSetup.vue